import TemporaryNotifications from './TemporaryNotifications.page';

export default TemporaryNotifications;
